import Axios from 'axios';
import config from '@/config/index';
import { message } from 'ant-design-vue';
import { removeAccount } from './user';
interface IAccount {
  token: string;
}
const Account = {
  token: '',
};
export const changeAccount = (obj: IAccount) => {
  Account.token = obj.token;
};

const httpRequest = Axios.create({
  baseURL: config.baseUrl,
});
httpRequest.interceptors.request.use((requestConfig) => {
  if (Account.token) {
    requestConfig.headers.Authorization = 'Bearer ' + Account.token;
  }
  return requestConfig;
}, (error) => {
  return Promise.reject(error);
});
httpRequest.interceptors.response.use((response) => {
  if (!response.data.success) {
    const error = new Error(response.data.message || 'Error');
    return Promise.reject(error);
  }
  if (!response.data.message) {
    response.data.message = 'Success';
  }
  return response.data;
}, (error) => {
  if (error.response) {
    if (error.response.status === 401) {
      message.error('登录已失效');
      removeAccount();
      location.reload();
    }
  }
  return Promise.reject(error);
});

export const getRequestConfig = (): {baseURL: string, headers: any} => ({
  baseURL: config.baseUrl,
  headers: {
    Authorization: 'Bearer ' + Account.token,
  },
});

export default httpRequest;
